// extracted by mini-css-extract-plugin
export default {"content":"support_content__q1O21"};